import React, { Fragment } from "react";
import { DotLegalDialog, DotLegalMultiSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { ExternalUserViewModel } from "../ExternalUser.types";
import { useAddEditExternalUserDialogHook } from "./AddEditExternalUserDialog.hooks";
import DialogHeaderWithInformation from "@common/components/dialogHeaderWithInformation/DialogHeaderWithInformation";

export interface IAddEditExternalUserDialogProps {
    externalUser: ExternalUserViewModel | undefined;
    onCloseDialog: () => void;
    onSave: (externalUserId: string) => void;
}

function AddEditExternalUserDialog(props: IAddEditExternalUserDialogProps) {
    const { translateString } = useTranslation();
    const { isEdit, saveModel, modelUpdater, errors, inProgress, onSave, businessAreaOptions, businessAreaIsLoading } = useAddEditExternalUserDialogHook(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            header={
                <DialogHeaderWithInformation
                    header={isEdit ? translateString("editExternalUser") : translateString("createExternalUser")}
                    information={isEdit ? undefined : translateString("externalUsersInfo")}
                />
            }
            open
            onDialogClose={props.onCloseDialog}
            onOkClick={onSave}
            buttonOkText={isEdit ? translateString("save") : translateString("create")}
            size="sm"
            disableBackdropOnCloseIfValueChange={saveModel}
            isLoading={businessAreaIsLoading}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.fullName}
                debounce={false}
                onChange={modelUpdater.onFullNameChange}
                errorText={errors.fullNameError}
            />
            <DotLegalTextField
                label={translateString("email")}
                value={saveModel.email}
                debounce={false}
                onChange={modelUpdater.onEmailChange}
                errorText={errors.emailError}
            />
            <DotLegalMultiSelect
                isLoading={businessAreaIsLoading}
                label={translateString("businessAreas")}
                placeholder={translateString("businessAreas")}
                options={businessAreaOptions}
                chosenOptions={saveModel?.businessAreas!}
                onChange={modelUpdater.onBusinessAreasChange}
                noOptionsLabel={translateString("noOptions")}
            />
        </DotLegalDialog>
    );
}

export default AddEditExternalUserDialog;
